import { Box, type SxProps, type Theme } from "@mui/material";
import { useThemeColor } from "../hooks/useThemeColor";

function IconInACircle(props: { icon: JSX.Element; variant?: "default" | "muted"; sx?: SxProps<Theme> }) {
  const { icon, variant, sx } = props;
  const primaryColor = useThemeColor("primary");

  return (
    <Box
      sx={{
        backgroundColor: variant === "muted" ? "action.hover" : primaryColor.main,
        color: variant === "muted" ? "text.secondary" : primaryColor.contrastText,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: 40,
        width: 40,
        aspectRatio: "1",
        borderRadius: "50%",
        ...sx,
      }}
    >
      {icon}
    </Box>
  );
}

export default IconInACircle;
